import React from "react";
import { Compass, Eye } from "lucide-react";

const AboutMission = () => {
  return (
    <section className="bg-[#fdfaf5] py-24 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12">
        {/* Mission Card */}
        <div className="bg-white p-12 rounded-lg shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 bg-[#fdfaf5] rounded-full flex items-center justify-center mb-8">
            <Compass className="text-[#D4AF37]" size={28} />
          </div>
          <h3 className="text-2xl font-serif text-[#D4AF37] mb-6">Our Mission</h3>
          <p className="text-gray-700 leading-relaxed">
            To serve our customers with exquisitely designed, hallmarked
            jewelry that celebrates life's precious moments. We're
            committed to spreading awareness about jewelry purity, ethical
            sourcing, and fair business practices while preserving
            traditional craftsmanship.
          </p>
        </div>

        {/* Vision Card */}
        <div className="bg-white p-12 rounded-lg shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 bg-[#fdfaf5] rounded-full flex items-center justify-center mb-8">
            <Eye className="text-[#D4AF37]" size={28} />
          </div>
          <h3 className="text-2xl font-serif text-[#D4AF37] mb-6">Our Vision</h3>
          <p className="text-gray-700 leading-relaxed">
            To become the market leader of North Bihar by setting the
            highest standards in jewelry quality, customer service,
            and innovation. We envision a future where every family
            trusts Hirapanna for their most cherished jewelry
            purchases.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutMission;
